import React from 'react';
import { Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart } from 'recharts';
import Icon from '../../../components/AppIcon';

const QuarterlyTrendChart = ({ data, onDrillDown }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-md shadow-lg p-3">
          <p className="font-heading font-semibold text-sm text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4 mb-1">
              <span className="caption text-xs" style={{ color: entry?.color }}>
                {entry?.name}:
              </span>
              <span className="data-text text-xs font-medium text-foreground">
                {entry?.name === 'Compliance' ? `${entry?.value}%` : 
                 entry?.name === 'Payroll' ? `K ${entry?.value?.toLocaleString()}` :
                 entry?.value}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
        <div>
          <h3 className="font-heading font-semibold text-lg text-foreground mb-1">
            Quarterly Performance Trends
          </h3>
          <p className="caption text-sm text-muted-foreground">
            Compliance scores, workforce growth, and payroll costs by quarter
          </p>
        </div>
        <button
          onClick={() => onDrillDown?.('/workforce-analytics')}
          className="flex items-center gap-2 text-sm text-primary hover:underline"
        >
          <span>View Details</span>
          <Icon name="ArrowRight" size={16} color="var(--color-primary)" />
        </button>
      </div>

      <div className="w-full h-80 lg:h-96" aria-label="Quarterly Trends Chart">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="quarter" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'var(--font-caption)' }}
            />
            <YAxis 
              yAxisId="left"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'var(--font-data)' }}
            />
            <YAxis 
              yAxisId="right"
              orientation="right"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'var(--font-data)' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px', fontFamily: 'var(--font-caption)' }}
            />
            <Bar 
              yAxisId="left"
              dataKey="workforce" 
              fill="var(--color-accent)" 
              name="Workforce"
              radius={[4, 4, 0, 0]}
            />
            <Line 
              yAxisId="right"
              type="monotone" 
              dataKey="compliance" 
              stroke="var(--color-success)" 
              strokeWidth={3}
              name="Compliance"
              dot={{ fill: 'var(--color-success)', r: 5 }}
            />
            <Line 
              yAxisId="left"
              type="monotone" 
              dataKey="payroll" 
              stroke="var(--color-primary)" 
              strokeWidth={2}
              name="Payroll"
              dot={{ fill: 'var(--color-primary)', r: 4 }}
              strokeDasharray="5 5"
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default QuarterlyTrendChart;